<script setup>
import { ref } from 'vue'
import axios from 'axios'
import SmartCaptcha from 'vue3-smart-captcha'

const dialog = ref(false)
const isLoading = ref(false)

const name = ref('')
const text = ref('')
const nameTextRules = ref([
    (value) => {
        if (value) return true
        return 'Обязательное поле для заполнения'
    }
])

const email = ref('')
const emailRules = ref([
    (value) => {
        if (value) return true

        return 'Обязательное поле для заполнения'
    },
    (value) => {
        if (/.+@.+\..+/.test(value)) return true

        return 'Неверный вид Email'
    }
])

const SMARTCAPTCHA_KEY = process.env.VUE_APP_SMARTCAPTCHA_KEY
const captchaToken = ref('')

const handleSuccessCaptcha = (token) => {
    captchaToken.value = token
}

const sendFeedback = async () => {
    if (
        name.value.trim().length === 0 ||
        text.value.trim().length === 0 ||
        email.value.trim().length === 0 ||
        !/.+@.+\..+/.test(email.value) ||
        captchaToken.value.trim().length === 0
    ) {
        alert('Проверьте веденные данные и попробуйте еще раз')
        return
    }

    let startUrl = ''
    if (process.env.VUE_APP_SERVER_URL) {
        startUrl = process.env.VUE_APP_SERVER_URL
    }
    if (!startUrl) {
        startUrl = window.location.origin + '/api'
    }

    isLoading.value = true

    try {
        await axios.post(startUrl + '/feedback', {}, {
            params: {
                sender_name: name.value,
                sender_email: email.value,
                text: text.value,
                captcha_token: captchaToken.value
            }
        })

        alert('Сообщение было успешно отправлено')

        name.value = ''
        email.value = ''
        text.value = ''
    } catch (error) {
        if (error.status === 403) {
            alert('Вы не прошли проверку CAPTCHA')
        } else if (error.status === 503) {
            alert('Произошла ошибка на сервере, попробуйте позднее')
        }
    } finally {
        dialog.value = false
        captchaToken.value = ''
        isLoading.value = false
    }
}
</script>

<template>
    <v-dialog
        v-model="dialog"
        max-width="800"
    >
        <template v-slot:activator="{ props: activatorProps }">
            <v-btn
                v-bind="activatorProps"
                height="136"
                width="100%"
                color="#001FA3"
            >
                <div>
                    <div class="useful-card-content">
                        <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M32 3.5C32 1.575 30.56 0 28.8 0H3.2C1.44 0 0 1.575 0 3.5V24.5C0 26.425 1.44 28 3.2 28H28.8C30.56 28 32 26.425 32 24.5V3.5ZM30 2.1875L16 13.5625L2 2.1875H30ZM30 25.8125H2V4.375L16 15.75L30 4.375V25.8125Z"
                                fill="white"
                            />
                        </svg>
                        <div class="useful-card-text important-card-text">
                            Корпоративная почта
                        </div>
                    </div>
                </div>
            </v-btn>
        </template>

        <template v-slot:default>
            <v-card>
                <div class="container">
                    <h1 class="title">Обратная связь</h1>
                    <form
                        class="inputs"
                        @submit.prevent="sendFeedback"
                    >
                        <v-text-field
                            v-model="name"
                            :rules="nameTextRules"
                            label="Как к вам обращаться?"
                            variant="outlined"
                        />
                        <v-text-field
                            v-model="email"
                            :rules="emailRules"
                            label="Укажите Ваш Email для обратной связи"
                            variant="outlined"
                        />
                        <v-textarea
                            v-model="text"
                            :rules="nameTextRules"
                            label="Текст сообщения"
                            variant="outlined"
                        />
                        <SmartCaptcha
                            :sitekey="SMARTCAPTCHA_KEY"
                            hl="ru"
                            @success="handleSuccessCaptcha"
                        />
                        <v-btn
                            class="submit-btn"
                            color="rgba(59, 102, 211, 1)"
                            :disabled="captchaToken.trim().length === 0 || isLoading"
                            type="submit"
                        >
                            {{ !isLoading ? 'Отправить' : 'Отправка...' }}
                        </v-btn>
                    </form>
                </div>
            </v-card>
        </template>
    </v-dialog>
</template>

<style lang="scss" scoped>
.container {
    padding: 40px 50px;
}

.title {
    font-size: 28px;
    font-weight: 500;
    line-height: 36px;
}

.inputs {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.submit-btn {
    width: 100%;
    height: 56px;
}
</style>
